import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import brasil from '../../../assets/icons/languages/ptbr.webp';
import espanha from '../../../assets/icons/languages/es.webp';
import eua from '../../../assets/icons/languages/en.webp';
import { FlagImage, LanguageButton, LanguageSelector } from './styles';

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [activeButtonLanguage, setActiveButtonLanguage] = useState('pt');

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    setActiveButtonLanguage(language);
  };

  return (
    <LanguageSelector>
      <LanguageButton
        className={activeButtonLanguage === 'pt' ? 'active' : ''}
        type="button"
        onClick={() => changeLanguage('pt')}
      >
        <FlagImage src={brasil} alt="brasil" />
      </LanguageButton>
      <LanguageButton
        className={activeButtonLanguage === 'en' ? 'active' : ''}
        type="button"
        onClick={() => changeLanguage('en')}
      >
        <FlagImage src={eua} alt="eua" />
      </LanguageButton>
      <LanguageButton
        className={activeButtonLanguage === 'es' ? 'active' : ''}
        type="button"
        onClick={() => changeLanguage('es')}
      >
        <FlagImage src={espanha} alt="espanha" />
      </LanguageButton>
    </LanguageSelector>
  );
}

export default LanguageSwitcher;
